import { DatePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { isObject } from 'lodash';
import { DateTime } from 'luxon';
import { BehaviorSubject, Subscription } from 'rxjs';

import {
  InventoryTransaction,
  InventoryTransactionLookUp,
} from '@app/core/_constant/inventory-transaction.constant';
import { AuthService } from '@app/core/auth/services/auth.service';
import { AuthInterface } from '@app/core/client/store/client.model';
import { InventoryService } from '@app/core/inventory/services/inventory.service';
import { InventoryTransactionConstant } from '@app/core/inventory/store/inventory.model';
import { EFeatureFlag } from '@app/feature-toggle-list';
import { QtyTypePipe } from '@app/shared/pipes/qty-type.pipe';
import { FeatureToggleService } from '@app/shared/services/feature-toggle.service';
import { trimWala } from '@app/shared/utils/string.utils';

@Component({
  selector: 'cnc-rfq-details-qty-logs',
  templateUrl: './rfq-details-qty-logs.component.html',
  styleUrls: ['./rfq-details-qty-logs.component.scss'],
})
export class RfqDetailsQtyLogsComponent implements OnInit, OnDestroy {
  @Input() rfq :any;

  initialize :boolean = false;
  length = 0;
  pageSize = 20;
  pageSizeOptions :number[] = [5, 10, 25, 100];
  searchKey :string = '';
  authData :AuthInterface;
  showFilters :boolean = true;

  loading$ :BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  filter :any = {
    qty_type: '',
    transaction: '',
    order_number: '',
    order_date: '',
    channel: '',
    warehouseGroup: '',
    warehouse: '',
  };
  params :any = {};

  inventoryTransactionLookUp :typeof InventoryTransactionLookUp =
    InventoryTransactionLookUp;

  recordSub :Subscription;
  records :any = { data: [] };
  lotTrackingEnabled :boolean = false;
  inventoryTransaction :any = InventoryTransaction;
  datePipe :DatePipe = new DatePipe('en');

  constructor(
    private invSvc :InventoryService,
    private cd :ChangeDetectorRef,
    private ffService :FeatureToggleService,
    private authService :AuthService,
    private router :Router,
  ) {}

  ngOnInit() {
    this.authData = this.authService.getUser();
    this.filter.qty_type = 'qty_onhand';
    this.getRecords();
    this.lotTrackingEnabled = this.ffService.featureEnabled(
      EFeatureFlag.LOT_TRACKING,
    );
  }

  ngOnDestroy() {
    this.recordSub.unsubscribe();
  }

  getRecords(event ?:any, page ?:number, paramsOnly ?:boolean) {
    if (page) {
      this.params.page = page;
    }
    this.params = Object.assign(this.params, this.filter);
    if (!this.filter.qty_type || this.filter.qty_type.trim().length == 0) {
      delete this.params.qty_type;
    }
    if (event) {
      this.params.page = event.pageIndex + 1;
      this.params.per_page = event.pageSize;
    }
    if (this.params.order) {
      this.params.order = trimWala(this.params.order, '-');
    }
    if (paramsOnly) {
      return this.params;
    }
    this.loading$.next(true);
    this.params.rfq_id = this.rfq.id;

    this.recordSub = this.invSvc.getQtyLogs(this.params).subscribe((resp :any) => {
      if (resp.data) {
        this.records = resp;
        this.records.data.forEach((row) => {
          if (row.action === InventoryTransactionConstant.DEDUCT_ACTION) {
            row.quantity = (row.orderedQty ? row.orderedQty : row.quantity) * -1;
          } else {
            row.quantity = row.orderedQty ? row.orderedQty : row.quantity;
          }
          row.hasLocationAndBalance =
            row?.location && row?.locationRunningBalance !== null;
        });
      }
      this.loading$.next(false);
      this.cd.detectChanges();
    });
  }

  setOrder(order :string) {
    if (this.filter.order && this.filter.order == order) {
      this.filter.order = '-' + order;
      this.filter.sort = 'desc';
    } else {
      this.filter.order = order;
      this.filter.sort = 'asc';
    }

    this.getRecords(false, 1);
  }

  onSelectWarehouseFilter(warehouseId :number) {
    this.filter.warehouse = warehouseId;
  }

  resetFilters() :void {
    const { qty_type, ...restFilters } = this.filter;
    const isAllEmpty = Object.values(restFilters).every((value) => value === '');
    const isQtyTypeUnchanged = qty_type === 'qty_onhand';

    if (isAllEmpty && isQtyTypeUnchanged) {
      return;
    }

    this.showFilters = false;
    setTimeout(() => {
      this.filter = {
        qty_type: 'qty_onhand',
        transaction: '',
        order_number: '',
        order_date: '',
        channel: '',
        warehouseGroup: '',
        warehouse: '',
      };

      this.showFilters = true;
      this.cd.detectChanges();

      this.getRecords(false, 1);
    }, 0);
  }
}
